/*
* @描述: 报价单编辑
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-31 16:19:50
*/
<template>
    <div class="quotation_add_page">
        <div class="quotation_add_header">
            <div class="flex_wrap">
                <div class="back_btn flex_wrap" @click="handleClickReturn">
                    <i class="el-icon-arrow-left"></i>
                    <span class="back_text">返回</span>
                </div>
                <span class="line"></span>
                <div class="page_title">编辑模板</div>
            </div>
            <div class="quotation_add_submit">
                <el-button type="primary"
                           @click="handleClickSubmit"
                           :disabled="btnDisabled"
                           size="mini">加入推荐
                </el-button>
            </div>
        </div>
        <div v-loading="loading" class="quotation_add_content">
            <div class="quotation_add_form_wrap">
                <div class="quotation_add_form_top">
                    <div v-if="!understood" class="quotation_add_hint">
                        <div class="flex_wrap">
                            <i class="iconfont icon-tishi"></i>
                            <p class="hint_text">
                                提示：长按拖动字段更换顺序；鼠标移入各行可以添加或删除行，可以在空白表格中自行填写字段名称与内容</p>
                        </div>
                        <el-link :underline="false" type="primary" @click="understood=true">知道了</el-link>
                    </div>
                    <TemplateComponent :project_quotation_tmpl_form="project_quotation_tmpl_form"
                                       v-if="dataLoaded"
                                       :fields_list="formInfoList"
                                       ref="templateComponent"
                                       :templateType="'edit'"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TemplateComponent from "@/views/pc/Business/component/template_component";
import quotationTemplate from "./component/quotation_template";
import {createTmpl, getFormFields} from "@/api";
import {uploadImg} from '@/utils/uploadOss'
import html2canvas from "html2canvas";

export default {
    name: "QuotationTemplateEdit",
    data() {
        return {
            project_quotation_tmpl_form: this.$route.query.project_quotation_tmpl_form,
            is_system: Number(this.$route.query.is_system),
            loading: false,
            understood: false,
            dataLoaded: false,
            btnDisabled: false,
            formInfoList: []
        }
    },
    components: {TemplateComponent, quotationTemplate},
    created() {
        this.loading = true
        getFormFields({
            field_form: this.project_quotation_tmpl_form
        }).then(res => {
            if (res.code === 200) {
                this.formInfoList = res.data
                this.dataLoaded = true
            } else {
                this.$message.error(res.message)
            }
            this.loading = false
        }).catch(() => {
            this.loading = false
        })
    },
    computed: {},
    mounted() {

    },
    methods: {
        //返回
        handleClickReturn() {
            this.$router.go(-1)
        },

        //提交
        handleClickSubmit() {
            const {quotationForm, templateFieldsList} = this.$refs.templateComponent
            if (this.is_system === 1) {
                const that = this
                html2canvas(this.$refs.templateComponent.$refs.template_review_wrap, {
                    allowTaint: true, // 允许跨域图片污染
                    useCORS: true,    // 使用 CORS 处理跨域图片
                    scale: 1.2,
                }).then((canvas) => {
                    const image = canvas.toDataURL("image/png");
                    let file = new window.File([that.dataURItoBlob(image)], '模板预览图.jpg', {type: 'image/jpeg'})
                    uploadImg(file).then((res) => {
                        const tmpl_url = res.file_path
                        this.$prompt('模板名称：', '加入后，可供员工报价时使用', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputValidator: (value) => {
                                if (!value) return '请输入模板名称'
                                if (value.trim().length > 15) return '模板名称不能超过15个字符'
                            },
                            inputErrorMessage: '请输入模板名称',
                            inputPlaceholder: '请输入模板名称',
                            iconClass: 'iconfont icon-shuoming',
                            customClass: 'icon_title_message_box icon_title_message_box_warning'
                        }).then(({value}) => {
                            this.btnDisabled = true
                            const data = {
                                name: value,
                                tmpl_url: tmpl_url,
                                form_company_logo: quotationForm.form_company_logo,
                                form_title: quotationForm.form_title,
                                source_form: this.project_quotation_tmpl_form,
                                field_list: templateFieldsList
                            }
                            createTmpl(data).then(res => {
                                if (res.code === 200) {
                                    this.$message.success('添加成功')
                                    this.$router.go(-1)
                                } else {
                                    this.$message.error(res.message)
                                    this.btnDisabled = false
                                }
                            })
                        }).catch(() => {

                        });
                    }).catch(() => {
                    })
                })
            } else {

            }
        },

        dataURItoBlob(base64Data) {
            let byteString
            if (base64Data.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(base64Data.split(',')[1])
            } else {
                byteString = unescape(base64Data.split(',')[1])
            }
            let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
            let ia = new Uint8Array(byteString.length)
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ia], {type: mimeString})
        },
    },
}
</script>
<style lang="scss" scoped>
.quotation_add_page {
    width: 100%;
    height: 100%;

    .quotation_add_header {
        padding: 12px 16px;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .back_btn {
            cursor: pointer;

            .back_text {
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: #666666;
            }
        }

        .page_title {
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;
            color: #333333;
        }
    }

    .quotation_add_content {
        width: 100%;
        height: calc(100% - 49px);
        background-color: #EDF0F4;

        .quotation_add_form_wrap {
            width: 1016px;
            height: 100%;
            margin: 0 auto;
            background-color: #FFFFFF;
            border-radius: 8px;

            .quotation_add_form_top {
                width: 100%;
                height: 100%;
                padding: 24px;
                overflow-y: auto;

                .quotation_add_hint {
                    padding: 9px 16px;
                    border-radius: 4px;
                    background: rgba(41, 144, 255, 0.16);
                    border: 1px solid rgba(41, 144, 255, 0.34);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 16px;

                    .icon-tishi {
                        color: #2990FF;
                    }

                    .hint_text {
                        line-height: 22px;
                        color: #333333;
                        margin-left: 4px;
                    }
                }
            }
        }
    }
}
</style>
